import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ViewState } from 'app/models/app';
import { firstValueFrom } from 'rxjs';

export class DispatchTaskModalComponentInput {
    title?: string;
    text?: string;
    icon?: 'success' | 'error' | 'warning' | 'info' | 'question';
    confirmButtonText?: string;
    confirmButtonColor?: string;
    showCancelButton?: boolean;
    cancelButtonText?: string;
    endpoint: string;
}

@Component({
    selector: 'app-dispatch-task-modal',
    templateUrl: './dispatch-task-modal.component.html',
    styleUrls: ['./dispatch-task-modal.component.css']
})
export class DispatchTaskModalComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<DispatchTaskModalComponent>,
        @Inject(MAT_DIALOG_DATA) public input: DispatchTaskModalComponentInput,
        private http: HttpClient
    ) {}

    //vars
    title: string;
    text: string;
    icon: 'success' | 'error' | 'warning' | 'info' | 'question';
    isComplete = false;

    //view states
    viewStates = ViewState;
    viewState = ViewState.content;

    ngOnInit(): void {
        this.title = this.input.title;
        this.text = this.input.text;
        this.icon = this.input.icon;
    }

    //actions
    async onConfirm(): Promise<void> {
        this.viewState = ViewState.loading;
        this.dialogRef.disableClose = true;

        try {
            await firstValueFrom(this.http.get(this.input.endpoint));
            this.showSuccess();
        } catch (err) {
            this.showError(this.errorMessage(err));
        }
    }

    onDismiss(): void {
        this.dialogRef.close(this.isComplete);
    }

    //ui
    showSuccess(): void {
        this.isComplete = true;
        this.icon = 'success';
        this.title = 'Task dispatched successfully';
        this.text = null;
        this.viewState = ViewState.content;
        this.dialogRef.disableClose = false;
    }

    showError(error: string): void {
        this.isComplete = true;
        this.icon = 'error';
        this.title = 'Failed to dispatch task';
        this.text = error;
        this.viewState = ViewState.content;
        this.dialogRef.disableClose = false;
    }

    errorMessage(err: any): string {
        const body = err?.error;
        if (typeof body === 'string' && body.trim()) {
            return body;
        }

        return body?.detail
            ?? body?.message
            ?? body?.error
            ?? body?.title
            ?? err?.message
            ?? 'An unexpected error occurred';
    }

    modalIcon(): string {
        switch (this.icon) {
            case 'success':
                return 'heroicons_outline:check';
            case 'error':
                return 'heroicons_outline:x-circle';
            case 'warning':
                return 'heroicons_outline:exclamation';
            case 'info':
                return 'heroicons_outline:information-circle';
            case 'question':
                return 'heroicons_outline:question-mark-circle';
            default:
                return '';
        }
    }

    modalIconColor(): string {
        switch (this.icon) {
            case 'success':
                return 'text-emerald-500';
            case 'error':
                return 'text-rose-500';
            case 'warning':
                return 'text-amber-500';
            default:
                return '';
        }
    }

    modalConfirmButtonClass(): string {
        switch (this.icon) {
            case 'success':
                return 'confirm-button-success';
            case 'error':
                return 'confirm-button-error';
            case 'warning':
                return 'confirm-button-warning';
            default:
                return '';
        }
    }
}
